import MarkdocContent from "~/components/cms/mdoc-content";
import CardUI from "~/components/ui/card";
import type { FaqDocument } from "~/types/docs/faq-document";

interface FaqItemProps {
  faq: FaqDocument;
  open: boolean;
  toggle: (_: number) => void;
}

export default function FaqItem({ faq, toggle, open }: FaqItemProps) {
  return (
    <CardUI
      variant="faq"
      onClick={() => toggle(faq.id)}
      className="cursor-pointer overflow-hidden rounded-xl px-1 py-2 sm:px-3"
    >
      <CardUI.Body>
        <button className="flex w-full cursor-pointer items-center justify-between bg-none p-4 transition">
          <div className="text-base font-semibold text-white sm:text-lg md:text-xl">
            {faq.question}
          </div>
          <div className="h-8 w-8 pr-2">
            <FaqIcon rotate={open} />
          </div>
        </button>

        <div
          className={`grid transition-all duration-300 ease-in-out ${
            open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
          }`}
        >
          <div className="overflow-hidden">
            <div className="p-4 text-right text-lg text-gray-400">
              <MarkdocContent markdown={faq.answer} />
            </div>
          </div>
        </div>
      </CardUI.Body>
    </CardUI>
  );
}


const FaqIcon = ({ rotate }: { rotate: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={`h-6 w-6 ${rotate ? "rotate-45" : "rotate-0"}`}
    >
      <path
        d="M12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9L11.25 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H11.25V15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15L12.75 12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.75V9Z"
        fill="white"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
        fill="white"
      ></path>
    </svg>
  );
};
